import { Question } from './Question';

export class VideoQuestion extends Question {
  isValid: boolean;

  constructor() {
    super();
    this.type = 'Video';
    this.isValid = false;
  }
}
